var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content-wrapper",staticStyle:{"padding-bottom":"0"}},[_c('app-breadcrumb',{attrs:{"page-title":_vm.data.name,"icon":'package'}}),_vm._v(" "),_c('div',[_c('b',[_vm._v(_vm._s(_vm.$t('team_id'))+": ")]),_vm._v(_vm._s(_vm.data.id))])],1),_vm._v(" "),_c('pinnacle-teams-datatable',{attrs:{"team_id":_vm.data.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }